import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <nav className="w-full py-5 px-6 md:px-12 flex items-center justify-between bg-white sticky top-0 z-50 relative" data-id="element-172">
      <a href="/" data-id="element-173">
        <img src="https://cdn.magicpatterns.com/uploads/db5KgZuCqgcppcR1ZMRgzN/Valuan_CRM_Logo_ok.jpg" alt="Valuan CRM" className="h-7 w-auto object-contain" data-id="element-174" />
      </a>

      {/* Desktop buttons */}
      <div className="hidden md:flex items-center gap-4" data-id="element-175">
        <a href="https://valuancrm.com/" className="text-black px-4 py-2.5 text-[16px] font-display font-medium hover:text-[#1F46D5] transition-colors" data-id="element-176">
          Inicio
        </a>
        <a href="https://app.valuancrm.com/" target="_blank" rel="noopener noreferrer" className="bg-white border border-gray-300 text-black px-6 py-2.5 rounded-full text-[16px] font-display font-medium hover:bg-gray-50 transition-colors inline-block text-center" data-id="element-177">
          Acceder a mi Cuenta
        </a>
        <a href="https://api.whatsapp.com/send?phone=525511362283&text=Vi su sitio web, me interesa Valuan CRM…" target="_blank" rel="noopener noreferrer" className="border border-gray-300 text-black px-6 py-2.5 rounded-full text-[16px] font-display font-medium hover:bg-gray-50 transition-colors inline-block text-center" data-id="element-178">
          Contactar Ventas
        </a>
        <a href="https://valuancrm.com/prueba-gratuita" className="text-btn bg-[#1F46D5] px-6 py-2.5 rounded-full hover:bg-[#152E8A] transition-colors inline-block text-center" data-id="element-179">
          Probar ahora
        </a>
      </div>

      {/* Mobile hamburger */}
      <button className="md:hidden text-gray-700 hover:text-black transition-colors" onClick={() => setMenuOpen(!menuOpen)} aria-label="Abrir menú" data-id="element-180">
        {menuOpen ? <XIcon className="w-6 h-6" data-id="element-181" /> : <MenuIcon className="w-6 h-6" data-id="element-182" />}
      </button>

      {/* Mobile menu */}
      {menuOpen && <div className="absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg flex flex-col gap-3 p-6 md:hidden z-50" data-id="element-183">
          <a href="/" className="text-black px-6 py-3 text-[15px] font-display font-medium hover:text-[#1F46D5] transition-colors text-center" data-id="element-184">
            Inicio
          </a>
          <a href="https://app.valuancrm.com/" target="_blank" rel="noopener noreferrer" className="bg-white border border-gray-300 text-black px-6 py-3 rounded-full text-[15px] font-display font-medium hover:bg-gray-50 transition-colors text-center" data-id="element-185">
            Acceder a mi Cuenta
          </a>
          <a href="https://api.whatsapp.com/send?phone=525511362283&text=Vi su sitio web, me interesa Valuan CRM…" target="_blank" rel="noopener noreferrer" className="border border-gray-300 text-black px-6 py-3 rounded-full text-[15px] font-display font-medium hover:bg-gray-50 transition-colors text-center" data-id="element-186">
            Contactar Ventas
          </a>
          <a href="https://valuancrm.com/prueba-gratuita" className="text-btn bg-[#1F46D5] px-6 py-3 rounded-full hover:bg-[#152E8A] transition-colors text-center" data-id="element-187">
            Probar ahora
          </a>
        </div>}
    </nav>;
}